// extracted by mini-css-extract-plugin
export default {"card":"CancelAutorenewErrorModal__card--14VAd","text":"CancelAutorenewErrorModal__text--2bZ1h"};